import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CheckType from "@/utils/CheckType";

export default /*#__PURE__*/_defineComponent({
  __name: 'Img',
  props: {
  item: {
    type: [Object],
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createBlock(_component_el_image, {
    class: "img",
    src: _unref(CheckType).isImg(props.item.link),
    "preview-src-list": [_unref(CheckType).isImg(props.item.link)],
    fit: "cover"
  }, null, 8, ["src", "preview-src-list"]))
}
}

})